/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Weight_InvalidInputs */

const vi_carrier_form_weight_invalid = /** @type {(inputs: Carrier_Form_Weight_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng kiện hàng phải là số nguyên lớn hơn 0 gram.`)
};

/**

* @param {Carrier_Form_Weight_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_weight_invalid = /** @type {((inputs?: Carrier_Form_Weight_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Weight_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_weight_invalid(inputs)
});